export const articles = [
  {
    id: 1,
    title: "Sedekah Sampah: Dari Masjid, Untuk Bumi",
    category: "Lingkungan",
    date: "12 Agustus 2026",
    readTime: "4 menit",
    summary:
      "Bagaimana jamaah Masjid Baitussalam mengubah sampah terpilah menjadi berkah — untuk lingkungan dan kas sosial masjid.",
    thumbnail:
      "https://images.unsplash.com/photo-1604187351574-c75ca79f5807?q=80&w=1200&auto=format&fit=crop",
    content: [
      {
        type: "p",
        text: "Setiap Jumat pagi, pemandangan baru terlihat di halaman Masjid Baitussalam, Kedungwuni Barat. Jamaah datang tidak hanya membawa sajadah, tetapi juga kantong-kantong berisi botol plastik, kardus, dan kertas bekas yang sudah dipilah rapi dari rumah. Inilah Sedekah Sampah — program unggulan KKN-PLP Terintegrasi Angkatan 65 Kelompok 55 yang mengubah cara warga memandang sampah.",
      },
      { type: "h2", text: "Sampah yang Disedekahkan, Berkah yang Dibagikan" },
      {
        type: "p",
        text: "Konsepnya sederhana namun kuat: sampah anorganik yang terpilah memiliki nilai ekonomi. Alih-alih dibuang ke sungai atau dibakar, jamaah menyerahkannya ke pos Sedekah Sampah di serambi masjid. Mahasiswa KKN dan kader bank sampah menimbang, mencatat, lalu menyalurkannya ke pengepul mitra. Hasil penjualannya masuk ke kas sosial masjid.",
      },
      {
        type: "p",
        text: "Dalam tiga pekan pertama, tercatat lebih dari 320 kilogram sampah terpilah terkumpul dari 85 keluarga. Dana yang terhimpun digunakan untuk membantu biaya pengobatan warga kurang mampu dan membeli perlengkapan kebersihan masjid.",
      },
      {
        type: "quote",
        text: "Selama ini kami hanya tahu sedekah itu uang. Ternyata sampah pun bisa jadi amal kalau niatnya benar dan pengelolaannya baik.",
        author: "H. Ahmad Syaifudin, Takmir Masjid Baitussalam",
      },
      { type: "h2", text: "Sistem yang Mudah Ditiru" },
      {
        type: "p",
        text: "Agar berkelanjutan, tim KKN 55 menyusun panduan pemilahan bergambar yang ditempel di setiap rumah, membentuk kader Sedekah Sampah dari kalangan remaja masjid, dan menjadwalkan penimbangan rutin setiap Jumat dan Ahad. Warga juga mendapat buku tabungan sampah sehingga hasil penjualan bisa dipantau transparan.",
      },
      {
        type: "p",
        text: "Program ini adalah bagian dari Gerakan Eco Masjid — menjadikan rumah ibadah sebagai pusat peradaban hijau. Ke depan, model Sedekah Sampah direncanakan direplikasi ke masjid-masjid lain se-Kecamatan Kedungwuni dengan pendampingan kader yang sudah terlatih.",
      },
    ],
  },
  {
    id: 2,
    title: "KKN 55 Adakan Bimbingan Belajar Gratis untuk 120 Siswa",
    category: "Pendidikan",
    date: "8 Agustus 2026",
    readTime: "3 menit",
    summary:
      "Empat sekolah mitra di Kedungwuni Barat kini punya kelas sore gratis: matematika, bahasa Inggris, dan pojok literasi.",
    thumbnail:
      "https://images.unsplash.com/photo-1577896851231-70ef18881754?q=80&w=1200&auto=format&fit=crop",
    content: [
      {
        type: "p",
        text: "Senin sampai Kamis sore, ruang kelas SDN 01 Kedungwuni Barat kembali hidup. Puluhan siswa duduk berkelompok, mengerjakan soal matematika ditemani mahasiswa KKN-PLP Terintegrasi Angkatan 65 Kelompok 55. Program bimbingan belajar gratis ini kini diikuti 120 siswa dari empat sekolah mitra.",
      },
      { type: "h2", text: "Tiga Program dalam Satu Atap" },
      {
        type: "p",
        text: "Bimbingan belajar KKN 55 terbagi menjadi tiga layanan: kelas numerasi untuk matematika dasar, kelas English Fun yang mengenalkan bahasa Inggris lewat lagu dan permainan, serta pojok literasi berisi koleksi buku cerita dan ensiklopedia anak yang disusun rapi di setiap sekolah mitra.",
      },
      {
        type: "p",
        text: "Sebagai bagian dari PLP (Praktik Lapangan Persekolahan), mahasiswa juga berkesempatan mengajar di kelas formal dengan pendampingan guru pamong. Materi disusun menyesuaikan kurikulum sekolah sehingga apa yang dipelajari sore hari selaras dengan pelajaran pagi hari.",
      },
      {
        type: "quote",
        text: "Anak-anak jadi berani bertanya dan semangat mengerjakan PR. Kami berharap program seperti ini bisa terus ada setiap semester.",
        author: "Ibu Sri Wahyuni, S.Pd., Guru SDN 01 Kedungwuni Barat",
      },
      { type: "h2", text: "Dampak yang Mulai Terlihat" },
      {
        type: "p",
        text: "Dari evaluasi awal, lebih dari 80 persen peserta menunjukkan peningkatan nilai tugas harian. Yang lebih membanggakan, minat baca siswa naik signifikan — pojok literasi kini selalu ramai saat jam istirahat. Program ini akan ditutup dengan pentas literasi yang menampilkan karya tulis dan baca puisi para siswa.",
      },
    ],
  },
  {
    id: 3,
    title: "Eco Masjid: Ketika Rumah Ibadah Menjadi Pusat Peradaban Hijau",
    category: "Eco Masjid",
    date: "3 Agustus 2026",
    readTime: "5 menit",
    summary:
      "Jumat bersih, dakwah hijau, dan kader lingkungan — inilah wajah baru masjid-masjid di Kedungwuni Barat.",
    thumbnail:
      "https://images.unsplash.com/photo-1584551246679-0daf3d275d0f?q=80&w=1200&auto=format&fit=crop",
    content: [
      {
        type: "p",
        text: "Masjid selalu menjadi pusat kehidupan masyarakat Muslim — tempat shalat, belajar, dan bermusyawarah. KKN-PLP Terintegrasi Angkatan 65 Kelompok 55 menambahkan satu fungsi baru: pusat gerakan peduli lingkungan. Melalui Gerakan Eco Masjid, masjid-masjid di Kedungwuni Barat mulai bertransformasi menjadi teladan hidup bersih dan hijau.",
      },
      { type: "h2", text: "Empat Pilar Gerakan Eco Masjid" },
      {
        type: "p",
        text: "Gerakan ini berdiri di atas empat pilar. Pertama, Jumat Bersih: aksi rutin membersihkan masjid dan lingkungan sekitarnya sebelum shalat Jumat. Kedua, dakwah hijau: materi khutbah dan kajian yang mengangkat tema kepedulian lingkungan dalam perspektif Islam. Ketiga, Sedekah Sampah: jamaah menyetorkan sampah terpilah sebagai bentuk amal. Keempat, kader Eco Masjid: remaja masjid yang dilatih menjadi penggerak lingkungan.",
      },
      {
        type: "p",
        text: "Di Masjid Baitussalam, perubahan langsung terasa. Tempat sampah terpilah tiga warna kini tersedia di setiap sudut, taman kecil dengan tanaman produktif menghiasi halaman, dan air wudhu ditampung untuk menyiram tanaman.",
      },
      {
        type: "quote",
        text: "Kebersihan adalah bagian dari iman. Eco Masjid membuat pesan itu benar-benar hidup di tengah jamaah.",
        author: "Farhan Hidayatullah, Koordinator Keagamaan KKN 55",
      },
      { type: "h2", text: "Dari Satu Masjid ke Masjid Lainnya" },
      {
        type: "p",
        text: "Hingga pertengahan pengabdian, tiga masjid di Kedungwuni Barat telah bergabung dalam gerakan ini. Setiap masjid memiliki kader terlatih dan panduan replikasi yang disusun tim KKN 55 bersama takmir. Harapannya, ketika masa pengabdian berakhir, gerakan ini terus berjalan mandiri — dikelola warga, untuk warga, dari rumah Allah untuk bumi yang lebih bersih.",
      },
    ],
  },
  {
    id: 4,
    title: "Digitalisasi Administrasi Mempermudah Layanan Kelurahan",
    category: "Digitalisasi",
    date: "28 Juli 2026",
    readTime: "4 menit",
    summary:
      "Dari arsip kertas ke sistem digital — mahasiswa KKN 55 mendampingi perangkat kelurahan bertransformasi.",
    thumbnail:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=1200&auto=format&fit=crop",
    content: [
      {
        type: "p",
        text: "Tumpukan map dan buku catatan di kantor Kelurahan Kedungwuni Barat perlahan berkurang. Dalam dua pekan terakhir, mahasiswa KKN-PLP Terintegrasi Angkatan 65 Kelompok 55 mendampingi perangkat kelurahan memindahkan arsip penting ke format digital yang rapi dan mudah dicari.",
      },
      { type: "h2", text: "Apa yang Dikerjakan" },
      {
        type: "p",
        text: "Tim digitalisasi KKN 55 membantu tiga hal utama: pendataan ulang arsip surat menyurat ke dalam spreadsheet terstruktur, pembuatan template surat layanan umum agar pelayanan lebih cepat dan seragam, serta penyusunan kalender kegiatan kelurahan digital yang bisa diakses perangkat dari mana saja.",
      },
      {
        type: "p",
        text: "Tidak berhenti di situ, tim juga mengadakan pelatihan singkat untuk para perangkat — dari cara mengelola berkas di Google Drive hingga membuat formulir daring untuk pendataan warga. Materi pelatihan dibukukan dalam modul sederhana agar bisa dipelajari ulang kapan pun.",
      },
      {
        type: "quote",
        text: "Dulu mencari satu arsip bisa setengah jam. Sekarang tinggal ketik nama, langsung ketemu. Mahasiswa ini sangat membantu.",
        author: "H. M. Choirul Anam, Lurah Kedungwuni Barat",
      },
      { type: "h2", text: "UMKM Juga Ikut Naik Kelas" },
      {
        type: "p",
        text: "Digitalisasi tidak hanya menyentuh kantor kelurahan. Beberapa pelaku UMKM binaan dibantu membuat katalog produk digital dan foto kemasan yang lebih menarik untuk dipromosikan lewat WhatsApp dan media sosial. Dengan bekal ini, jangkauan pasar produk lokal Kedungwuni Barat diharapkan semakin luas.",
      },
    ],
  },
  {
    id: 5,
    title: "Warga Kedungwuni Barat Antusias Ikuti Kerja Bakti Massal",
    category: "Sosial",
    date: "21 Juli 2026",
    readTime: "3 menit",
    summary:
      "Ratusan warga turun membersihkan saluran air dan menanam 150 bibit pohon produktif di sepanjang jalan utama.",
    thumbnail:
      "https://images.unsplash.com/photo-1593113598332-cd288d649433?q=80&w=1200&auto=format&fit=crop",
    content: [
      {
        type: "p",
        text: "Minggu pagi itu, jalan utama Kedungwuni Barat berubah menjadi lautan semangat gotong royong. Ratusan warga — dari bapak-bapak, ibu PKK, karang taruna, hingga anak-anak — turun bersama mahasiswa KKN-PLP Terintegrasi Angkatan 65 Kelompok 55 dalam kerja bakti massal.",
      },
      { type: "h2", text: "Saluran Bersih, Lingkungan Sehat" },
      {
        type: "p",
        text: "Sasaran utama kerja bakti adalah saluran air yang selama ini tersumbat sampah dan sedimentasi — penyebab genangan saat hujan deras. Berkelompok per RT, warga membersihkan gorong-gorong, mengangkut lumpur, dan memangkas rumput liar di bahu jalan.",
      },
      {
        type: "p",
        text: "Setelah saluran bersih, kegiatan dilanjutkan dengan penanaman 150 bibit pohon produktif — mangga, jambu, dan trembesi — di sepanjang jalan utama dan lahan kosong milik kelurahan. Setiap bibit mendapat penanda nama kelompok penanam agar perawatannya berkelanjutan.",
      },
      {
        type: "quote",
        text: "Sudah lama lingkungan kami tidak seramai ini. Adik-adik KKN datang, warga jadi tergerak lagi untuk gotong royong.",
        author: "Ketua Karang Taruna Kedungwuni Barat",
      },
      {
        type: "p",
        text: "Kerja bakti ditutup dengan sarapan bersama hasil masakan ibu-ibu PKK. Kebersamaan inilah yang menjadi catatan terindah: lingkungan yang bersih lahir dari warga yang kompak. Kegiatan serupa direncanakan menjadi agenda rutin bulanan yang diwariskan kepada karang taruna setempat.",
      },
    ],
  },
  {
    id: 6,
    title: "Tahsin TPQ Al-Ikhlas Capai Target Juz 30",
    category: "Keagamaan",
    date: "15 Juli 2026",
    readTime: "3 menit",
    summary:
      "Program tahsin intensif selama dua pekan berbuah manis — santri TPQ semakin fasih dan percaya diri.",
    thumbnail:
      "https://images.unsplash.com/photo-1585036156171-384164a8c675?q=80&w=1200&auto=format&fit=crop",
    content: [
      {
        type: "p",
        text: "Suara lantunan ayat suci menggema setiap sore dari TPQ Al-Ikhlas, Kedungwuni Barat. Selama dua pekan, mahasiswa KKN-PLP Terintegrasi Angkatan 65 Kelompok 55 menggelar program tahsin intensif — dan hasilnya membanggakan: seluruh santri kelas juz 30 mencapai target kelancaran yang ditetapkan.",
      },
      { type: "h2", text: "Metode yang Menyenangkan" },
      {
        type: "p",
        text: "Program tahsin dirancang tidak menegangkan. Santri dibagi dalam kelompok kecil berisi empat sampai lima anak, masing-masing dibimbing satu mahasiswa. Perbaikan makharijul huruf dan tajwid dilakukan lewat metode talaqqi, diselingi permainan hafalan dan kuis surah pendek yang membuat anak-anak tetap antusias.",
      },
      {
        type: "p",
        text: "Selain membina santri, tim KKN 55 juga berbagi teknik mengajar dengan para ustadz dan ustadzah TPQ — mulai dari pengelolaan kelas, kartu evaluasi bacaan, hingga sistem pencapaian berbintang yang memotivasi santri untuk terus maju.",
      },
      {
        type: "quote",
        text: "Anak saya sekarang setiap sore berangkat sendiri ke TPQ tanpa disuruh. Bacaannya juga jauh lebih fasih.",
        author: "Salah satu orang tua santri TPQ Al-Ikhlas",
      },
      {
        type: "p",
        text: "Program ditutup dengan khatmil Qur'an dan pemberian apresiasi untuk santri paling berkembang. Buku panduan tahsin dan kartu evaluasi diserahkan kepada pengelola TPQ agar pembinaan berlanjut setelah masa KKN usai.",
      },
    ],
  },
];
